module.exports = __webpack_public_path__ + "media/images/social/linkedin-04ca7103c4a8fb89aa17f08765ecda7d.png";